const mixin = {
  computed: {
    pathDocs() {
      return `${process.env.VUE_APP_API_DOCS_URI}`;
    },
    defaultAvatar() {
      return '/images/default-avatar.png';
    },
  },
  methods: {
    imgPath(img) {
      if (img) return `${this.pathDocs}${img}`;
      return this.defaultAvatar;
    },
  },
};

export default mixin;
